import { t } from '@lingui/core/macro';
import { Alert, Box, UserAvatar } from '@pocketlaw/tetris';
export function ApproversPermissionList(props) {
    const { approvers } = props;
    const deletedUser = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    return (<Box flexDirection="column" gap="lg">
      <Alert appearance="warning" message={t({
            comment: 'Warning message that appears if the document has approvers without access to the document itself when the user is asking for approval',
            message: 'The following users do not have access to this document. You will have to grant them access to the document before selecting them as approvers.',
        })}/>
      {approvers.map((approver) => (<UserAvatar key={approver.userId} size="sm" title={approver.name || deletedUser}/>))}
    </Box>);
}
